// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"94c4dc41","379":"ec8bd3be","532":"1d7dff6f","664":"35a2e206","703":"ed9b9dbc","969":"2bb3dd6b"}[chunkId] + ".chunk.js";
};